exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n  padding-top: 6px;\n  padding-bottom: 6px; }\n\n.itm {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.even {\n  background: #ddd; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/recon-history/recon-history-item/recon-history-item.component.scss
// module id = ../../../../../src/app/views/daily-recon/recon-history/recon-history-item/recon-history-item.component.scss
// module chunks = main